import React, { Component } from 'react';
import Slider from 'react-slick';
import './homeSlider.css';
import {PrimaryBookLink, BookstoreBookLink, GrumpleAmazonLink, GrumpleSquareLink} from "./../../utils/constants";


import { Parallax } from 'react-scroll-parallax';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class HomeSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0
    };
    this.sliderRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (e) => {
    if (e.key === 'ArrowRight') {
      this.sliderRef.current.slickNext();
    } else if (e.key === 'ArrowLeft') {
      this.sliderRef.current.slickPrev();
    }
  }

  handleBeforeChange = (oldIndex, newIndex) => {
    this.setState({ currentSlide: newIndex });
  }

  getButtonColor = () => {
    const { currentSlide } = this.state;
    // Red for sale slide (index 0), Brown for grumple slide (index 1), Blue for joys of jet lag slide (index 2)
    if (currentSlide === 0) return '#df272b';
    if (currentSlide === 1) return '#8B4513';
    return '#16a5c4';
  }

  renderSaleSlide = () => (
    <div className="slide-content sale-slide">
      <div className="sale-slide-background">
        <div className="sale-slide-overlay">
          {/* Title */}
          <h1 className="white sale-title">
            Black Friday Sale
          </h1>
          
          {/* 3 Column Image Grid */}
          <div className="row sale-grid">
            <div className="small-12 medium-4 tiny-padding">
              <div className="sale-card">
                <img 
                  src="/images/blk-friday-gift-stack.png" 
                  alt="Gift Bundle" 
                  className="sale-image"
                />
                <div className="sale-card-content">
                  <h6 className="sale-subtitle">Grumple Gift Bundle</h6>
                  <h2 className="white sale-card-title">
                    Buy 4 Get 1 Free
                  </h2>
                  <a target="_blank" href="https://square.link/u/NIQMIXct" className="sale-link">
                    <div className="button sale-button">
                      Buy Now
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="small-12 medium-4 tiny-padding">
              <div className="sale-card">
                <img 
                  src="/images/blk-friday-signed-grumple.png" 
                  alt="Signed Grumple" 
                  className="sale-image"
                />
                <div className="sale-card-content">
                  <h6 className="sale-subtitle">Signed Copy</h6>
                  <h2 className="white sale-card-title">
                    <s>$25.99</s> $19.99
                  </h2>
                  <a target="_blank" href="https://square.link/u/U2iDao9q" className="sale-link">
                    <div className="button sale-button">
                      Buy Now
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="small-12 medium-4 tiny-padding">
              <div className="sale-card">
                <img   
                  src="/images/blk-friday-signed-joys.png" 
                  alt="Signed Joys of Jet Lag" 
                  className="sale-image"
                />
                <div className="sale-card-content">
                  <h6 className="sale-subtitle">Signed Copy</h6>
                  <h2 className="white sale-card-title">
                    <s>$19.99</s> $14.99
                  </h2>
                  <a target="_blank" href="https://square.link/u/l1ZK6itw" className="sale-link">
                    <div className="button sale-button">
                      Buy Now
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  renderGrumpleSlide = () => (
    <div className="slide-content">
      <div className="full-height full-width black-background background-image-fill centered-text homepage-hero-back" style={{backgroundImage:'url(/images/grumple-back.jpg)'}}>
        <div className="full-height full-width" style={{backgroundColor:"rgba(0,0,0,.15)",padding:"10%",paddingTop:"10%", paddingBottom:"0%", position:"relative", overflow:"hidden"}}>
          <Parallax y={[0, -10]} styleInner={{height:"100%", width:"100%"}} styleOuter={{height:"100%", width:"100%"}}>
            <div className="full-height full-width" style={{position:"relative", display:"flex",justifyContent:"center"}}>
              <div className="full-width homepage-overlay-tex grumple-front full-height" style={{
                display:"flex", 
                alignItems:"flex-end", 
                justifyContent:"center", 
                maxWidth:"90vh", 
                height:"90vh", 
                backgroundImage:'url(/images/grumple-front.png)', 
                backgroundSize:'contain', 
                backgroundPosition:'bottom center', 
                backgroundRepeat:'no-repeat',
                position: 'absolute',
                bottom: '80px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 2
              }}>
                
              </div>
            </div>
          </Parallax>
          <div style={{position:'absolute', bottom:'0px', width:'100%', textAlign:'center', left:0, backgroundColor:'#392a1d', zIndex: 3}}>
            <div style={{paddingBottom:"10px", paddingTop:"10px", maxWidth:800, marginLeft:"auto", marginRight:"auto"}}>
              <div className="row">
                <div className="small-12 medium-6">
                  <div className="tiny-padding">
                    <a target="_blank" href={GrumpleSquareLink}>
                      <div className="button primary-background white full-width" style={{backgroundColor:"#dfa440", color:"#392a1d"}}>{'Buy Now'}</div>
                    </a>
                  </div>
                </div>
                <div className="small-12 medium-6">
                  <div className="tiny-padding">
                    <a target="_blank" href={GrumpleAmazonLink}>
                      <div className="button primary-background white full-width" style={{backgroundColor:"#dfa440", color:"#392a1d"}}>{'Buy on Amazon.com'}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  renderJoysSlide = () => (
    <div className="slide-content">
      <div className="full-height full-width black-background background-image-fill centered-text homepage-hero-back joys-hero" style={{backgroundImage:'url(/images/home-hover.jpg)'}}>
        <div className="full-height full-width" style={{backgroundColor:"rgba(0,0,0,.15)",padding:"10%",paddingTop:"10%", paddingBottom:"0%", position:"relative", overflow:"hidden"}}>
          <Parallax y={[0, -10]} styleInner={{height:"100%", width:"100%"}} styleOuter={{height:"100%", width:"100%"}}>
            <div className="full-height full-width" style={{position:"relative", display:"flex",justifyContent:"center"}}>
            <div className="hide-for-small" style={{height:"100%", width:"100%"}}>
                <div className="full-width homepage-overlay-tex grumple-front full-height" style={{
                    display:"flex", 
                    alignItems:"center", 
                    justifyContent:"center", 
                    width:"100%", 
                    height:"90vh", 
                    position: 'absolute',
                    bottom: '80px',
                    zIndex: 2,
                    textAlign: 'center',
                    fontSize: '40px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                  <h1 className="white" style={{fontSize: '40px', fontWeight: 'bold', color: 'white', fontSize: '100px', textShadow: '2px 10px 40px rgba(0, 0, 0, 0.5)'}}>THE JOYS OF JET LAG</h1>
                </div>
              </div>
              <div className="show-for-small" style={{height:"100%", width:"100%"}}>
                <div className="full-width homepage-overlay-tex grumple-front full-height" style={{
                  display:"flex", 
                  alignItems:"center", 
                  justifyContent:"center", 
                  maxWidth:"90vh", 
                  height:"90vh", 
                  position: 'absolute',
                  bottom: '80px',
                  left: '50%',
                  zIndex: 2,
                  textAlign: 'center',
                  fontSize: '40px',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  <img src="/images/book-cover-angle.png" style={{width: '100%', transform: 'scale(1.5)'}} />
                </div>
              </div>
            </div>
          </Parallax>
          <div className="primary-background" style={{position:'absolute', bottom:'0px', width:'100%', textAlign:'center', left:0, zIndex: 3}}>
            <div style={{paddingBottom:"10px", paddingTop:"10px", maxWidth:800, marginLeft:"auto", marginRight:"auto"}}>
              <div className="row">
                <div className="small-12 medium-6">
                  <div className="tiny-padding">
                    <a target="_blank" href={BookstoreBookLink}>
                      <div className="button white-background primary-color full-width" style={{backgroundColor:"white", color:"#16a5c4"}}>{'Buy on Bookshop.org'}</div>
                    </a>
                  </div>
                </div>
                <div className="small-12 medium-6">
                  <div className="tiny-padding">
                    <a target="_blank" href={PrimaryBookLink}>
                      <div className="button primary-background white full-width" style={{backgroundColor:"white", color:"#16a5c4"}}>{'Buy on Amazon.com'}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const { currentSlide } = this.state;
    const buttonColor = this.getButtonColor();

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      pauseOnHover: true,
      arrows: false, // We'll use custom arrows
      beforeChange: this.handleBeforeChange,
      cssEase: 'ease-in-out'
    };

    return (
      <div className="code-slider">
        <Slider ref={this.sliderRef} {...settings}>
          <div>
            {this.renderGrumpleSlide()}
          </div>
          <div>
            {this.renderJoysSlide()}
          </div>
        </Slider>
        
        <button 
          onClick={() => this.sliderRef.current.slickPrev()} 
          className="control-button prev"
          style={{ backgroundColor: buttonColor }}
        >
          ←
        </button>
        <button 
          onClick={() => this.sliderRef.current.slickNext()} 
          className="control-button next"
          style={{ backgroundColor: buttonColor }}
        >
          →
        </button>
      </div>
    );
  }
}

export default HomeSlider; 


// WEBPACK FOOTER //
// ./src/components/homeSlider/homeSlider.js